import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import type { PriceImportRun } from './types';
import { priceImportsEndpointIdentifier } from './use-get-price-import-runs-api';

interface ResponseData {
  data: PriceImportRun;
}

type TData = ResponseData;
type TError = AxiosError;
type TQueryKey = [string, number | undefined];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetPriceImportRunApi(runId: number | undefined, options?: Options): ReturnType {
  const toast = useCustomToast();
  const isLoggedIn = useIsLoggedIn();

  const queryFn = async () => {
    try {
      const { data } = await http.get(`${priceImportsEndpointIdentifier}/${runId}`);
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({ description: error.response.data.message, status: 'error' });

      throw error;
    }
  };

  return useQueryWrapper([priceImportsEndpointIdentifier, runId], queryFn, {
    enabled: isLoggedIn && !!runId,
    ...options,
  });
}
